module.exports = __webpack_public_path__ + "static/media/option-1.fcf2dbe3.png";